(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pill"] && !Shopify.designMode) return;
  try {
    (function () {
  var observed = new WeakMap();

  function chromeWidth(pill) {
    var style = getComputedStyle(pill);
    var width = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    var dot = pill.querySelector('.ziip-pill__dot');
    if (dot) width += dot.getBoundingClientRect().width + (parseFloat(style.columnGap) || parseFloat(style.gap) || 0);
    return width;
  }

  function fit(pill) {
    var label = pill.querySelector('.ziip-pill__label');
    if (!label) return;
    pill.style.width = '';
    pill.classList.remove('ziip-pill--wrapped');
    var probe = document.createRange();
    probe.selectNodeContents(label);
    if (probe.getClientRects().length < 2) return;
    pill.classList.add('ziip-pill--wrapped');
    var limit = pill.parentElement ? pill.parentElement.clientWidth : Infinity;
    var extra = chromeWidth(pill);
    var width = 0;
    var guard = 0;
    while (guard < 3) {
      var range = document.createRange();
      range.selectNodeContents(label);
      var rects = range.getClientRects();
      if (rects.length < 2) {
        pill.style.width = '';
        pill.classList.remove('ziip-pill--wrapped');
        return;
      }
      var max = 0;
      for (var i = 0; i < rects.length; i++) max = Math.max(max, rects[i].width);
      var next = Math.min(limit, Math.ceil(max + extra));
      if (next === width) return;
      width = next;
      pill.style.width = width + 'px';
      guard += 1;
    }
  }

  function fitIn(root) {
    (root || document).querySelectorAll('.ziip-pill').forEach(fit);
  }

  function watch() {
    fitIn(document);
    if (!window.ResizeObserver) return;
    var observer = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        var width = Math.round(entry.contentRect.width);
        if (observed.get(entry.target) === width) return;
        observed.set(entry.target, width);
        entry.target.querySelectorAll(':scope > .ziip-pill').forEach(fit);
      });
    });
    document.querySelectorAll('.ziip-pill').forEach(function (pill) {
      if (!pill.parentElement || observed.has(pill.parentElement)) return;
      observed.set(pill.parentElement, Math.round(pill.parentElement.getBoundingClientRect().width));
      observer.observe(pill.parentElement);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitIn(document); });

  document.addEventListener('shopify:section:load', function (event) {
    fitIn(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
